import { Rarity } from '../types';

const LABELS: Record<Rarity, string> = {
  common: 'Common',
  uncommon: 'Uncommon',
  rare: 'Rare',
  'ultra-rare': 'Ultra Rare',
};

interface RarityBadgeProps {
  rarity: Rarity;
  className?: string;
}

export default function RarityBadge({ rarity, className = '' }: RarityBadgeProps) {
  return (
    <span className={`rarity-${rarity} text-xs font-semibold px-1.5 py-0.5 rounded uppercase tracking-wide ${className}`}>
      {LABELS[rarity]}
    </span>
  );
}
